import { render, staticRenderFns } from "./BulkAssign.vue?vue&type=template&id=dd304c36&"
import script from "./BulkAssign.vue?vue&type=script&lang=js&"
export * from "./BulkAssign.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports